'use client';

import { Button } from '@/components/originui/button';
import { generateInvitationLink } from '@/utils/membership/generate-invitation-link';
import notify from '@/utils/shared/notify';
import { Share } from 'lucide-react';

interface ShareInviteLinkButtonProps {
  token: string;
}

export default function ShareInviteLinkButton({ token }: ShareInviteLinkButtonProps) {
  const handleShare = async () => {
    try {
      await navigator.share({
        title: 'Piggo inbjudningslänk',
        text: 'Gå med i Piggogrupp!',
        url: generateInvitationLink(token),
      });
    } catch (err) {
      notify.error('Delning av inbjudningslänk misslyckades');
      console.error('Failed to share link: ', err);
    }
  };

  if (typeof navigator.share !== 'function') return;

  return (
    <Button variant="outline" className="disabled:opacity-100 w-full py-5" onClick={handleShare} aria-label={'Share'}>
      <div className="relative w-4 h-4">
        <Share className={'absolute transition-opacity duration-200 opacity-100'} size={16} aria-hidden="true" />
      </div>
      Dela inbjudningslänk
    </Button>
  );
}
